import LabelField from '@app/components/atoms/LabelField/LabelField'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank'
import Autocomplete from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const POSSection = ({ errors, setValue, pos, control, getValues, trigger }) => {
  const { t } = useTranslation()
  const checkedIcon = <CheckBoxIcon fontSize="small" />
  const icon = <CheckBoxOutlineBlank fontSize="small" />

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <LabelField required title={t('VOUCHER.CHOOSE_POS')}>
          <Controller
            control={control}
            name="pos"
            render={({ field }) => (
              <Autocomplete
                disableCloseOnSelect
                {...field}
                multiple
                getOptionLabel={(option) => option.address}
                id="checkboxes-pos"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                options={pos}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={errors.pos && !getValues('pos').length}
                    helperText={errors.pos && !getValues('pos').length ? errors.pos.message : ''}
                    onFocus={() => trigger('pos')}
                  />
                )}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox checked={selected} checkedIcon={checkedIcon} icon={icon} sx={{ mr: 8 }} />
                    {option.address}
                  </li>
                )}
                size="small"
                onChange={(e, value) => setValue('pos', value)}
              />
            )}
          />
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default POSSection
